<template>
  <v-footer class="pa-5">
    <v-row class="d-flex justify-space-between mx-12">
      <div class="icon-container">
        Made with
        <v-icon
          small
          :color="heartColor"
          class="icon-heart"
          @mouseover="startAnimation()"
          @mouseout="stopAnimation()"
        >
          mdi-heart
        </v-icon>
        <v-icon
          small
          class="note note1"
          :class="{ show: showNotes }"
          color="colorPtRoyal400"
        >
          mdi-music-note
        </v-icon>
        <v-icon
          small
          class="note note2"
          :class="{ show: showNotes }"
          color="colorPtRoyal400"
        >
          mdi-music
        </v-icon>
        <v-icon
          small
          class="note note3"
          :class="{ show: showNotes }"
          color="colorPtRoyal400"
        >
          mdi-music-note
        </v-icon>
        in Tennessee
      </div>
      <div class="d-flex align-center">
        © {{ currentYear }} ProviderTrust. All rights reserved.
        <v-divider vertical class="mx-4" />
        <a href="/client/terms">Privacy Policy</a>
        <v-divider vertical class="mx-4" />
        <a href="/client/terms">Terms of Service</a>
      </div>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => {
    return {
      showNotes: false,
      heartColor: "colorPtRoyal100",
      currentYear: new Date().getFullYear()
    };
  },
  methods: {
    startAnimation() {
      this.showNotes = true;
      this.heartColor = "colorSemanticStateRed600";
    },
    stopAnimation() {
      this.showNotes = false;
      this.heartColor = "colorPtRoyal100";
    }
  }
};
</script>

<style scoped lang="scss">
.v-footer {
  border-top: 1px solid $color-neutrals-navy-100;
  width: 100%;
}
.icon-container {
  position: relative;
  display: inline-block;

  .icon-heart {
    z-index: 2;
  }

  .note {
    position: absolute;
    opacity: 0;
    z-index: 1;
  }

  .note1.show {
    animation: x-motion 3s linear infinite, y-motion 3s linear infinite,
      fade-in-out 3s ease-in-out infinite;
  }

  .note2.show {
    animation: x-motion 3s linear 0.8s infinite,
      y-motion 3s linear 0.8s infinite, fade-in-out 3s ease-in-out 0.8s infinite;
  }

  .note3.show {
    animation: x-motion 3s linear 1.6s infinite,
      y-motion 3s linear 1.6s infinite, fade-in-out 3s ease-in-out 1.6s infinite;
  }

  @keyframes x-motion {
    0% {
      left: 38%;
    }
    100% {
      left: 75%;
    }
  }

  @keyframes y-motion {
    0% {
      top: 20%;
    }
    33% {
      top: -50%;
    }
    66% {
      top: -10%;
    }
    100% {
      top: -90%;
    }
  }

  @keyframes fade-in-out {
    0%,
    100% {
      opacity: 0;
    }
    25%,
    75% {
      opacity: 1;
    }
  }
}
</style>
